var render = function (_h,_vm) {var _c=_vm._c;return _c('img',_vm._b({class:_vm.data.staticClass,attrs:{"src":require("@/assets/images/incentive-video.jpg"),"width":_vm.props.width}},'img',_vm.data.attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }